module.exports = __webpack_public_path__ + "static/media/more-rounded.355199c8.svg";